import { Outlet } from 'react-router-dom'
import Sidebar from './Sidebar'
import Header from './Header'
import FloatingAIChat from '@components/FloatingAIChat'

export default function MainLayout() {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <Sidebar />
      <div className="lg:pl-64">
        <Header />
        <main className="p-6">
          <Outlet />
        </main>
        <footer className="p-6 text-center text-sm text-gray-500 dark:text-gray-400 border-t border-gray-200 dark:border-gray-700">
          © 2025 BravoSim - v1.0.5
        </footer>
      </div>
      
      {/* Plugin flutuante de IA - disponível em todas as páginas */}
      <FloatingAIChat />
    </div>
  )
}
